import { render, staticRenderFns } from "./ReleaseDialog.vue?vue&type=template&id=58d439c7&scoped=true&"
import script from "./ReleaseDialog.vue?vue&type=script&lang=ts&"
export * from "./ReleaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseDialog.vue?vue&type=style&index=0&id=58d439c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d439c7",
  null
  
)

export default component.exports